import { getLocalDateString } from './date';

export const isPreApprovedVisit = (visit) =>
  visit?.status === 'approved' && Boolean(visit?.preApproved);

export const getVisitStatusLabel = (visit) => {
  if (!visit?.status) return '';
  let label = visit.status;
  if (visit.status === 'approved') {
    const todayStr = getLocalDateString();
    const visitDateStr = getLocalDateString(visit.expectedDate || visit.createdAt);
    if (visitDateStr < todayStr) {
      label = 'not-visited';
    } else if (Boolean(visit.preApproved)) {
      label = 'pre-approved';
    }
  }
  
  // Capitalize first letter of each part (e.g. 'pre-approved' -> 'Pre-Approved')
  return label
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join('-');
};

export const getVisitStatusBadgeClass = (visit) => {
  if (visit?.status === 'approved') {
    const todayStr = getLocalDateString();
    const visitDateStr = getLocalDateString(visit.expectedDate || visit.createdAt);
    if (visitDateStr < todayStr) {
      return 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400';
    }
    if (Boolean(visit.preApproved)) {
      return 'bg-violet-50 text-violet-600 dark:bg-violet-900/30 dark:text-violet-400';
    }
    return 'bg-indigo-50 text-indigo-600 dark:bg-indigo-900/30 dark:text-indigo-400';
  }
  if (visit?.status === 'checked-in') {
    return 'bg-emerald-50 text-emerald-600 dark:bg-emerald-900/30 dark:text-emerald-400';
  }
  if (visit?.status === 'pending') {
    return 'bg-amber-50 text-amber-600 dark:bg-amber-900/30 dark:text-amber-400';
  }
  if (visit?.status === 'rejected') {
    return 'bg-rose-50 text-rose-600 dark:bg-rose-900/30 dark:text-rose-400';
  }
  return 'bg-slate-100 text-slate-500 dark:bg-slate-800/50 dark:text-slate-500';
};

export const matchesVisitStatusFilter = (visit, statusFilter) => {
  if (!statusFilter || statusFilter === 'All') return true;
  if (statusFilter === 'not-visited') {
    const todayStr = getLocalDateString();
    const visitDateStr = getLocalDateString(visit?.expectedDate || visit?.createdAt);
    return visit?.status === 'approved' && visitDateStr < todayStr;
  }
  if (statusFilter === 'pre-approved') return isPreApprovedVisit(visit);
  if (statusFilter === 'approved') {
    return visit?.status === 'approved' && !visit?.preApproved;
  }
  return visit?.status?.toLowerCase() === statusFilter.toLowerCase();
};

